// prepareChatMessage.js
'use strict';
import { v4 as uuidv4 } from 'uuid';

import createMessage from '../resource/createMessage.js';
import { UploadJobType } from '../resource/uploadConstants.js';
import { Purpose as AssetPurpose } from '../resource/assetConstants.js';

import login from '../action/login.js';
import addMessage from '../action/addMessage.js';
import addAsset from '../action/addAsset.js';
import addUploadJob from '../action/addUploadJob.js';
import submitChatMessage from '../action/submitChatMessage.js';

import getMeData from '../selector/getMeData.js';

import { ADD_LIST_ITEMS } from '../ActionTypes.js';

/**
 * Prepare chat message.
 * @kind action
 * @param {string} {text} - chat message.
 * @param {Media} {media} - media object.
 * @param {string} {chatroomId} - chatroom id.
 * @param {string} {replyMessageId} - replay message id.
 * @return {Promise} Action promise.
 */
const prepareChatMessage =
  ({ text, media, chatroomId, replyMessageId } = {}) =>
  async (dispatch, getState) => {
    const pendingListPath = ['chatroom', chatroomId, 'pendingMessages'];
    const token = getMeData(getState(), 'token');
    if (!token) {
      return dispatch(login());
    }
    const isReply = !!replyMessageId;
    const hasMedia = !!media;
    const uploadJobId = hasMedia ? uuidv4() : undefined;
    const assetId = hasMedia ? uuidv4() : undefined;
    const meId = getMeData(getState(), 'id');
    if (hasMedia) {
      dispatch(
        addAsset({
          assetId,
          uploadJobId,
          purpose: AssetPurpose.CHAT,
          file: media.fileBlob,
        })
      );
    }
    // TODO: add refetch field to mirate to new refetch behavior. see action/publishMessage.js
    const localMessage = createMessage({
      type: 'chat',
      text,
      media,
      senderId: meId,
      chatroomId,
      replyOfId: isReply ? replyMessageId : undefined,
      assetIds: hasMedia ? [assetId] : undefined,
      uploadJobId,
    });
    dispatch(addMessage({ message: localMessage }));
    dispatch({
      type: ADD_LIST_ITEMS,
      payload: {
        selectPath: pendingListPath,
        itemIds: [localMessage.id],
      },
    });
    if (hasMedia) {
      return dispatch(
        addUploadJob({
          uploadJobId,
          type: UploadJobType.CHAT,
          assetIds: [assetId],
          messageId: localMessage.id,
        })
      );
    }
    return dispatch(
      submitChatMessage({
        text,
        chatroomId,
        replyMessageId,
        localMessageId: localMessage.id,
      })
    );
  };

export default prepareChatMessage;
